<template>
  <div>
    <v-row>
      <v-col cols="1">
        <v-btn
          outlined
          icon
          x-large
          @click="back()"
        >
          <v-icon> {{ icons.mdiChevronLeft }}</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <span class="title">
          <h2> Selecione o pagamento </h2>
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-card
          class="card"
          outlined
          elevation="3"
          @click="showModalPaymentMoney()"
        >
          <v-card-text class="pt-4">
            <div class="text-center text_card">
              <v-icon
                color="success"
                x-large
              >
                {{ icons.mdiCash }}
              </v-icon>
            </div>
            <div class="text-center text_card">
              Dinheiro
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card
          class="card"
          outlined
          elevation="3"
          @click="showModalPaymentCard()"
        >
          <v-card-text class="pt-4">
            <div class="text-center text_card">
              <v-icon
                color="primary"
                x-large
              >
                {{ icons.mdiCreditCard }}
              </v-icon>
            </div>
            <div class="text-center text_card">
              Cartão de Crédito
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card
          class="card"
          outlined
          elevation="3"
          @click="showModalPaymentDebitCard()"
        >
          <v-card-text class="pt-4">
            <div class="text-center text_card">
              <v-icon
                color="success"
                x-large
              >
                {{ icons.mdiCreditCard }}
              </v-icon>
            </div>
            <div class="text-center text_card">
              Cartão de Débito
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card
          class="card"
          outlined
          elevation="3"
          @click="showModalPaymentPix()"
        >
          <v-card-text class="pt-4">
            <div class="text-center text_card">
              <img
                width="40"
                src="@/assets/images/logos/logo-pix.png"
                alt=""
              >
            </div>
            <div class="text-center text_card">
              Pix
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card
          class="card"
          outlined
          elevation="3"
          @click="showMultiplePaymentMethods()"
        >
          <v-card-text class="pt-4">
            <div class="text-center text_card">
              <v-icon
                color="error"
                x-large
              >
                {{ icons.mdiCashMultiple }}
              </v-icon>
            </div>
            <div class="text-center text_card">
              Mutiplas Formas
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="4">
        <v-card
          class="card"
          outlined
          elevation="3"
          @click="separatePayment()"
        >
          <v-card-text class="pt-4">
            <div class="text-center text_card">
              <v-icon
                color="primary"
                x-large
              >
                {{ icons.mdiDivisionBox }}
              </v-icon>
            </div>
            <div class="text-center text_card">
              Separar Pagamentos
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card
          class="card"
          outlined
          elevation="3"
          @click="showModalPaymentB2B()"
        >
          <v-card-text class="pt-4">
            <div class="text-center text_card">
              <v-icon
                color="warning"
                x-large
              >
                {{ icons.mdiHandshakeOutline }}
              </v-icon>
            </div>
            <div class="text-center text_card">
              B2B
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card
          class="card"
          outlined
          elevation="3"
          @click="showModalPaymentInvoice()"
        >
          <v-card-text class="pt-4">
            <div class="text-center text_card">
              <v-icon
                color="primary"
                x-large
              >
                {{ icons.mdiCalendarClock }}
              </v-icon>
            </div>
            <div class="text-center text_card">
              Faturamento
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col cols="4">
            <v-card class="card" outlined elevation="3" @click="showModalPaymentInvoice()">
                <v-card-text class="pt-4">
                    <div class="text-center text_card">
                        <v-icon color="warning" x-large> {{ icons.mdiHandshakeOutline  }}</v-icon>
                    </div>
                    <div class="text-center text_card">Adiantamento</div>
                </v-card-text>
            </v-card>
        </v-col> -->
      <!-- <v-col cols="4">
            <v-card class="card" outlined elevation="3" @click="addPaymentOther()">
                <v-card-text class="pt-4">
                    <div class="text-center text_card">
                        <v-icon color="warning" x-large> {{ icons.mdiCurrencyUsd }}</v-icon>
                    </div>
                    <div class="text-center text_card">Outros</div>
                </v-card-text>
            </v-card>
        </v-col> -->
    </v-row>
    <ModalPaymentMoney v-model="modalPaymentMoney" />
    <ModalPaymentPix v-model="modalPaymentPix" />
    <ModalPaymentCard v-model="modalPaymentCard" />
    <ModalPaymentDebitCard v-model="modalPaymentDebitCard" />
    <ModalPaymentInvoice v-model="modalPaymentInvoice" />
    <ModalPaymentB2B v-model="modalPaymentB2B" />
  </div>
</template>

<script>
import {
  mdiCog,
  mdiChevronLeft,
  mdiCash,
  mdiCreditCard,
  mdiCashMultiple,
  mdiCurrencyUsd,
  mdiDivisionBox,
  mdiHandshakeOutline,
  mdiCalendarClock,
} from '@mdi/js'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ModalPaymentMoney from './ModalPaymentMoney.vue'
import ModalPaymentPix from './ModalPaymentPix.vue'
import ModalPaymentCard from './ModalPaymentCreditCard.vue'
import ModalPaymentDebitCard from './ModalPaymentDebitCard.vue'
import ModalPaymentInvoice from './ModalPaymentInvoice.vue'
import ModalPaymentB2B from './ModalPaymentB2B.vue'

export default {
  components: {
    ModalPaymentMoney,
    ModalPaymentPix,
    ModalPaymentCard,
    ModalPaymentDebitCard,
    ModalPaymentInvoice,
    ModalPaymentB2B,
  },
  data() {
    return {
      tabs: null,

      modalPaymentMoney: false,
      modalPaymentPix: false,
      modalPaymentCard: false,
      modalPaymentDebitCard: false,
      modalPaymentInvoice: false,
      modalPaymentB2B: false,

      icons: {
        mdiChevronLeft,
        mdiCog,
        mdiCash,
        mdiCreditCard,
        mdiCashMultiple,
        mdiCurrencyUsd,
        mdiDivisionBox,
        mdiHandshakeOutline,
        mdiCalendarClock,
      },
    }
  },
  created() {
    this.loadPix()
    this.autoSeparateCorporateAccommodationWithConsumption()

    //   this.loadCreditCard()
    //   this.loadDebitCard()
  },
  computed: {
    ...mapGetters('checkout', ['getTotalToPay', 'getRoom', 'getItemsCheckout', 'getStage', 'getpaymentMethods', 'getPaymentMethodsPartial']),
  },
  watch: {
    getStage(val) {
      if (val === 'payment') {
        this.$nextTick(() => {
          this.autoSeparateCorporateAccommodationWithConsumption()
        })
      }
    },
    getItemsCheckout: {
      deep: true,
      handler() {
        this.autoSeparateCorporateAccommodationWithConsumption()
      },
    },
    getPaymentMethodsPartial: {
      deep: true,
      handler() {
        this.autoSeparateCorporateAccommodationWithConsumption()
      },
    },
  },
  methods: {
    ...mapMutations('checkout', ['setStage', 'addPaymentMethod', 'removePaymentMethod', 'clearResponsible', 'setMethodPayment']),
    ...mapActions('select', ['loadPix', 'loadCreditCard', 'loadDebitCard']),
    ...mapActions('company', ['getCompanyCredit']),

    showModalPaymentDebitCard() {
      this.modalPaymentDebitCard = true
    },
    showModalPaymentCard() {
      this.modalPaymentCard = true
    },
    showModalPaymentMoney() {
      this.modalPaymentMoney = true
    },
    showModalPaymentPix() {
      this.modalPaymentPix = true
    },
    async showModalPaymentInvoice() {
      const company = this.getRoom?.current_accommodation?.company
      if (company?.id && company?.allow_billing) {
        try {
          const response = await this.getCompanyCredit(company.id)
          const data = response?.data?.data || {}
          if (data.billing_blocked) {
            this.$swal({
              icon: 'error',
              title: 'Faturamento Bloqueado',
              html: `Esta empresa possui faturas vencidas há <strong>${data.overdue_days || 0} dias</strong>. Faturamento bloqueado.`,
              confirmButtonColor: '#FF4C51',
            })

            return
          }
        } catch (e) { /* deixa o backend rejeitar */ }
      }
      this.modalPaymentInvoice = true
    },
    showModalPaymentB2B() {
      this.modalPaymentB2B = true
    },
    showMultiplePaymentMethods() {
      this.setStage('multiple_payment_methods')
    },
    getBillingContext() {
      const accommodation = this.getRoom?.current_accommodation
      const reserve = accommodation?.reserve || this.getRoom?.current_reserve || accommodation

      const billingEnabled = reserve && (
        reserve.billing_checkout_enabled === true
        || reserve.billing_checkout_enabled === 1
        || reserve.billing_checkout_enabled === '1'
      )

      return {
        accommodation,
        reserve,
        billingEnabled,
        billingScope: reserve?.billing_checkout_scope || null,
      }
    },
    isConsumptionItem(item) {
      return item.origin === 'product' || item.origin === 'service'
    },
    isAccommodationItem(item) {
      return item.origin === 'accommodation' || item.origin === 'extra_tarif' || item.origin === 'accommodation_extra_item'
    },
    isWithIssEnabled() {
      const withIss = this.getRoom?.current_accommodation?.with_iss

      return withIss === true || withIss === 1 || withIss === '1' || withIss === 'yes' || withIss === 'true' || withIss === 'sim'
    },
    ensureCompanyInvoiceForAccommodation(company) {
      if (!company || !company.id) {
        return
      }

      const hasPartialInvoice = this.getPaymentMethodsPartial.some(method => {
        if (method.method !== 'invoice') {
          return false
        }

        if (!method.origin) {
          return true
        }

        return method.origin === 'company' && method.id == company.id
      })
      const invoicePayment = this.getpaymentMethods.find(method => method.method === 'invoice')

      if (hasPartialInvoice) {
        if (invoicePayment && invoicePayment.auto_billing) {
          this.removePaymentMethod(invoicePayment)
        }

        return
      }

      if (invoicePayment) {
        return
      }

      const withIss = this.isWithIssEnabled()
      const issRate = this.$store.getters['config/getIssRate'] || 0.03

      const invoiceValue = this.getItemsCheckout.reduce((acc, item) => {
        if (!this.isAccommodationItem(item)) {
          return acc
        }

        const quantity = Number(item?.pivot?.quantity ?? 1)
        const salePrice = Number(item.sale_price || 0)
        let total = salePrice * quantity

        if (item.origin === 'accommodation' && withIss) {
          total += issRate * salePrice * quantity
        }

        return acc + total
      }, 0)

      if (invoiceValue <= 0) {
        return
      }

      this.addPaymentMethod({
        method: 'invoice',
        value: invoiceValue,
        origin: 'company',
        id: company.id,
        billing_scope: 'accommodation',
        auto_billing: true,
      })
    },
    assignAccommodationItemsToCompany(company) {
      if (!company || !company.id) {
        return
      }

      this.getItemsCheckout.forEach(item => {
        if (this.isAccommodationItem(item)) {
          item.checked = true
          item.responsible = {
            ...company,
            origin: 'company',
          }
        }
      })
    },
    autoSeparateCorporateAccommodationWithConsumption() {
      const { accommodation, billingEnabled, billingScope } = this.getBillingContext()
      if (!billingEnabled || billingScope !== 'accommodation') {
        return
      }

      if (this.getStage !== 'payment' && this.getStage !== 'separate_payment') {
        return
      }

      const hasConsumption = this.getItemsCheckout.some(item => this.isConsumptionItem(item))
      if (!hasConsumption) {
        return
      }

      this.assignAccommodationItemsToCompany(accommodation?.company)
      this.ensureCompanyInvoiceForAccommodation(accommodation?.company)
      if (this.getStage === 'payment') {
        this.setStage('separate_payment')
        this.$toast.info('Hospedagem faturada na empresa. Defina o pagamento do consumo em Pagamento Separado.')
      }
    },
    back() {
      window.history.back()

      // this.$router.replace('/manager_room')
    },
    addPaymentOther() {
      const paymentMethod = {
        method: 'other',
        value: this.getTotalToPay,
        clearPayments: true,
      }

      this.addPaymentMethod(paymentMethod)
    },
    separatePayment() {
      this.clearResponsible() // limpa os reponsaveis pelo pagamento
      this.setMethodPayment() // limpa os methodo de pagamentos
      this.setStage('separate_payment')
    },
  },
}
</script>

<style scoped>
.card {
  height: 100px;
  cursor: pointer;
}

.card:hover {
  background: rgb(248, 248, 248);
}

.text_card {
  color: black;
  font-size: 16px;
}

.title {
  color: black;
  font-size: 25px;
}
</style>
